import React from "react";

import { connect } from "react-redux";
import FooterComponet from "../FooterComponent/FooterComponet";
import HeadeCommon from "../HeaderComponent/HeadeCommon";
import Menu from "../MenuComponent/Menu";
import '../RechargeComponent/recharge.css';
import { store } from "../../redux/store";

import BrowsePlans from "./BrowsePlans";
import TxnHistory from "./TxnHistory";
import MobileRecharge from "./MobileRecharge";
import DTHRecharge from "./DTHRecharge";
import ReviewRecharge from "./ReviewRecharge";
// import '../TransactionHistoryComponent/TransactionList.css';

// import 'mdbreact/dist/css/mdb.css';

import { resetAeps } from "../../redux/aeps/aeps.action";
import { resetBillPayData } from "../../redux/billpayDetails/billpay.action";
import { setCurrenntCircle, setCurrentOpertaor, setRechargeType, setRechrgeMobile, setShowRecargeSection } from "../../redux/recharge/recharge.action";


class Recharge extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            phoneNo: this.props.phone,
            message: '',
            showMobileSection: true,
            showDTHSection: false,
            activeIcon: 'Mobile',
            selectedOperator: '',

        }
    }


    selectMobileRecahrge = () => {
        this.setState({
            showMobileSection: true,
            showDTHSection: false,
            activeIcon: 'Mobile'
        })
        store.dispatch(setRechargeType('mobile'))

    }

    selectDthRecgarge = () => {
        this.setState({
            showMobileSection: false,
            showDTHSection: true,
            activeIcon: 'DTH'
        })
        store.dispatch(setRechargeType('dth'))
        store.dispatch(setShowRecargeSection('txnHistory'));
    }





    componentDidMount() {

        store.dispatch(setShowRecargeSection('txnHistory'));
        store.dispatch(setCurrentOpertaor(''));
        store.dispatch(setCurrenntCircle(''));
        store.dispatch(setRechrgeMobile(''));
        store.dispatch(setRechargeType('mobile'))

    }
    componentWillUnmount() {
    }

   

    render() {

        return (

            <div>
                <HeadeCommon />
                <Menu />

                <div class="main">
                    <div class="container-fluid">
                        <div class="row">
                            <div class="col-12 col-lg-5 col-xl-4">
                                <div class="card-b" id="leftdiv">
                                    <div class="head">
                                        <h3>Recharges</h3>
                                    </div>

                                    <div class="rechargeform">
                                        <div class="recharge-type">
                                            <ul>
                                                <li id="mobitab" class={this.state.activeIcon == 'Mobile' && 'active'}><i class="mobile" onClick={this.selectMobileRecahrge}></i> Mobile</li>
                                                <li id="dthtab" class={this.state.activeIcon == 'DTH' && 'active'}><i class="dth" onClick={this.selectDthRecgarge}></i> DTH</li>
                                            </ul>
                                        </div>
                                        {this.state.activeIcon == 'Mobile' &&
                                            <MobileRecharge />
                                        }
                                        {this.state.activeIcon == 'DTH' &&
                                            <DTHRecharge />
                                        }

                                    </div>
                                </div>
                            </div>

                            <div class="col-12 col-lg-7 col-xl-8">
                                <div class="card-b" id="rightdiv">

                                    {this.props.rechargeSection == 'txnHistory' &&
                                        <TxnHistory />
                                    }
                                    {(this.props.rechargeSection == 'plans') &&
                                        <BrowsePlans />
                                    }
                                    {(this.props.rechargeSection == 'review-recharge') &&
                                        <ReviewRecharge />
                                    }
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <FooterComponet />
            </div>


        );
    }
}

const mapStateToProps = (
    { errorMessageReduce: { errorMessage, loginErrorMessage },
        rechargeReduce: {  rechargeSection } }
) => ({
    errorMessage, loginErrorMessage, rechargeSection
});

export default connect(mapStateToProps, null)(Recharge);
